/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseComponent} from "../../../Components/BaseComponent";
import autobind from "autobind-decorator";

export class BaseFieldEditor extends BaseComponent {

	// Not used?
	// @autobind
	// updateFields(changes) {
	// 	const {OnUpdates} = this.props;
	//
	// 	OnUpdates?.(changes);
	// }

	// NumberFieldEditor and PhoneFieldEditor
	@autobind
	getFieldDefCustomData() {
		const {FieldDef} = this.props;

		return FieldDef?.customData || {};
	}

	// necessary for TextFieldEditor
	@autobind
	isDefaultInput() {
		const {FieldDef, DefaultSelectedFieldDefKey} = this.props;

		if (DefaultSelectedFieldDefKey && FieldDef) {
			return FieldDef.key === DefaultSelectedFieldDefKey;
		}

		return false;
	}

	_render() {
		return null;
	}

	render() {
		return this._render();
	}
}